import { render, staticRenderFns } from "./siteAdminList.vue?vue&type=template&id=a01ba9ee&scoped=true&"
import script from "./siteAdminList.vue?vue&type=script&lang=js&"
export * from "./siteAdminList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01ba9ee",
  null
  
)

export default component.exports